import Monitor from './monitor.vue';
export default Monitor;
